import { GlButton } from '../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import { mapActions, mapState } from '../../../../../node_modules/pinia/dist/pinia.mjs?vue3';
import { createAlert } from '../../alert.js?vue3';
import { __, n__ } from '~/locale';
import { useBatchComments } from '../store/index.js?vue3';
import { useNotes } from '../../notes/store/legacy_notes/index.js?vue3';
export default {
    name: 'SubmitReviewButton',
    components: {
        GlButton
    },
    computed: {
        ...mapState(useNotes, [
            'isNotesFetched'
        ]),
        ...mapState(useBatchComments, [
            'draftsCount',
            'isDraftsFetched',
            'isReviewer',
            'shouldAnimateReviewButton'
        ]),
        isLoading () {
            return !this.isNotesFetched || !this.isDraftsFetched;
        },
        draftsCountSrText () {
            return n__('draft', 'drafts', this.draftsCount);
        }
    },
    mounted () {
        this.fetchDrafts().catch((error)=>{
            createAlert({
                message: __('An error occurred while fetching pending comments'),
                captureError: true,
                error
            });
        });
    },
    methods: {
        ...mapActions(useBatchComments, [
            'fetchDrafts',
            'setDrawerOpened'
        ])
    }
};
